import { useQuery } from "@tanstack/react-query";
import { karlFarmGet } from "./queryClient";

// Route: GET /data/machines
// API Docs: n/a

export const getUseMachinesQueryKey = () => {
  return ["/data/machines"];
};

export const useMachines = () => {
  return useQuery(getUseMachinesQueryKey(), {
    queryFn: async () => {
      return karlFarmGet<MachinesResponse>(getUseMachinesQueryKey()[0]).catch(
        (error) => {
          if (error?.response?.status === 404) {
            // Patch 404 response to return empty array
            const emptyResponse: MachinesResponse = {
              messages: { status: "OK" },
              data: { machines: [], info: { returned_count: 0 } },
            };
            return emptyResponse;
          }
          throw error;
        }
      );
    },
  });
};

export type MachinesResponse = {
  messages: {
    status: "OK";
  };
  data: {
    machines: Machine[];
    info: {
      returned_count: number;
    };
  };
};

export const MACHINE_TYPE_MACHINE = 0;
export const MACHINE_TYPE_TOOL = 1;

type Machine = {
  machine_id: string;
  brand: string;
  model: string;
  description: string;
  type: typeof MACHINE_TYPE_MACHINE | typeof MACHINE_TYPE_TOOL;
  category: string; // TODO: Actual category type not specified yet.
  year_produced?: number;
  "consumer_id#enterprise_id": string;
};
